/**
 * @desc 启用 or 停用
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(params: API.esca.eChapter.enable.Params, options?: any) {
  return updateResponse(
    http(URL + `/eChapter/enable`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
